export default "__VITE_ASSET__DDWK7Cws__"